import type { AxiosInstance } from 'axios';

// FormValue mirrors the types stored in DynamicForm's dynamicFormData state
type FormValue = string | number | boolean | string[] | null;

export type FormEnhanceRequest = {
  formSchemaIdentifier: string;
  formData: Record<string, FormValue>;
};

export type FormEnhanceResponse = {
  fields: Array<{ fieldName: string; value: string }>;
};

export class FormEnhanceClient {
  constructor(private readonly authenticatedClient: AxiosInstance) {}

  enhance = (data: FormEnhanceRequest): Promise<FormEnhanceResponse> => {
    return this.authenticatedClient
      .post<FormEnhanceResponse>('/chat/form-enhance', data)
      .then((res) => res.data);
  };
}
